import { useState, useRef } from 'react';
import styles from '../../assets/css/AccountForgotUsernamePassword.module.css';
import Reaptcha from 'reaptcha';
import { IconAngleRight, IconLoadingCircle } from '@ace/react-icons';

const AccountForgotPassword = (props) => {
    const baseUrl = '/api/account';
    const [isLoading, setIsLoading] = useState(false);
    const [username, setUsername] = useState('');
    const [isUsernameValid, setIsUsernameValid] = useState(false);
    const [isInputChanged, setIsInputChanged] = useState(false);
    const [usernameSubmitted, setUsernameSubmitted] = useState(false);
    const [captchaToken, setCaptchaToken] = useState(null);
    const captchaRef = useRef(null);

    const onUsernameInputChange = (e) => {
        const providedUsername = e.target.value;

        setIsInputChanged(true);

        if (!providedUsername) {
            setIsUsernameValid(false);
            return;
        }
        setIsUsernameValid(true);
        setUsername(providedUsername);
    }

    const verifyCaptcha = () => {
        captchaRef.current.getResponse()
            .then(response => {
                setCaptchaToken(response)
            })
    }

    const onCaptchaExpired = () => {
        setCaptchaToken(null)
    }

    const onSubmitButtonClick = (e) => {
        e.preventDefault();
        setIsLoading(true);
        const data = { username: username }
        fetch(`${baseUrl}/send-password-reset`, {
            method: 'POST',
            headers: {
                'X-REQUESTED-WITH': 'XMLHttpRequest',
                'Content-Type': 'application/json',
                'RequestVerificationtoken': props.RequestVerificationToken
            },
            body: JSON.stringify(data)
        }).then(() => {
            setUsernameSubmitted(true);
            setIsLoading(false);
        })
    }

    return (
        <div className={styles.wrapper}>
            <h1>Forgot your password?</h1>
            <p>Enter the username associated with your ACE Business Account and we will send you instructions on how to reset your password.</p>
            <input type="text" name="username" id="username" placeholder="Enter username" onChange={onUsernameInputChange} />
            {isInputChanged && !isUsernameValid && <span className={styles.error}>Please enter a valid username</span>}
            <div className={styles.recaptchaWrap}>
                <Reaptcha
                    sitekey={process.env.RECAPTCHA_APP_KEY}
                    ref={captchaRef}
                    onVerify={verifyCaptcha}
                    onExpire={onCaptchaExpired}
                />
            </div>
            {(isUsernameValid && captchaToken && !usernameSubmitted && !isLoading) &&
                <button className={'ace-btn-primary'} onClick={e => onSubmitButtonClick(e)}>Submit <IconAngleRight /></button>
            }
            {isLoading && <IconLoadingCircle />}
            {usernameSubmitted &&
                <p>
                    Instructions on how to reset your password have been sent to the email address associated with your ACE Business Account. If you don't receive an email, please call us at 1-888-825-3636 or <a href="https://www.acefitness.org/btob/requestfacultylogin.aspx">request your login credentials online</a>.
                </p>
            }
        </div>
    )
}

export default AccountForgotPassword;